var map = {
	"./img_icon_avatar_001.png": 622,
	"./img_icon_avatar_002.png": 597,
	"./img_icon_avatar_003.png": 700,
	"./img_icon_avatar_004.png": 915,
	"./img_icon_avatar_005.png": 738,
	"./img_icon_avatar_006.png": 705,
	"./img_icon_avatar_007.png": 584,
	"./img_icon_avatar_008.png": 679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;